import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/cotton/admin/project/customSettings';

function baseApi() {
    function insert(data) {
        return Post(baseUrl + '/insertProjectCustomSetting', data);
    }

    function deleteData(data) {
        return Post(baseUrl + '/deleteProjectCustomSetting', data);
    }

    function update(data) {
        return Post(baseUrl + '/updateProjectCustomSetting', data);
    }

    function query(data) {
        return Post(baseUrl + '/queryProjectCustomSetting', data);
    }

    return {
        query,
        update,
        deleteData,
        insert
    };
}

export const projectCustomSettingApi = baseApi();